package twist.mena.sports.admin.theme

import androidx.compose.runtime.*

data class AppColors(
    val background: String,
    val surface: String,
    val surfaceHover: String,
    val primary: String,
    val primaryHover: String,
    val success: String,
    val danger: String,
    val warning: String,
    val info: String,
    val text: String,
    val textMuted: String,
    val border: String,
    val sidebar: String,
    val sidebarText: String,
    val sidebarActive: String,
    val cardBackground: String,
)

/** Light theme */
val LightColors = AppColors(
    background = "#f5f7f9",
    surface = "#ffffff",
    surfaceHover = "#f0f2f4",
    primary = "#63d86f",
    primaryHover = "#78e083",
    success = "#2ecc71",
    danger = "#d3173c",
    warning = "#f3c548",
    info = "#3498db",
    text = "#1a1d21",
    textMuted = "#6b7280",
    border = "#e2e5e9",
    sidebar = "#121316",
    sidebarText = "#e1ebf3",
    sidebarActive = "#1e2629",
    cardBackground = "#ffffff",
)

/** Dark theme — matches Twist Sports client */
val DarkColors = AppColors(
    background = "#121316",
    surface = "#171d20",
    surfaceHover = "#1e2629",
    primary = "#63d86f",
    primaryHover = "#78e083",
    success = "#2ecc71",
    danger = "#d3173c",
    warning = "#f3c548",
    info = "#3498db",
    text = "#e1ebf3",
    textMuted = "#7d869b",
    border = "#252a2e",
    sidebar = "#0d0f11",
    sidebarText = "#e1ebf3",
    sidebarActive = "#252f33",
    cardBackground = "#1e2226",
)

val LocalAppColors = compositionLocalOf { DarkColors }
val LocalIsDark = compositionLocalOf { true }

object AppTheme {
    val colors: AppColors
        @Composable @ReadOnlyComposable get() = LocalAppColors.current

    val isDark: Boolean
        @Composable @ReadOnlyComposable get() = LocalIsDark.current
}

@Composable
fun AppThemeProvider(isDark: Boolean, content: @Composable () -> Unit) {
    val colors = if (isDark) DarkColors else LightColors
    CompositionLocalProvider(
        LocalAppColors provides colors,
        LocalIsDark provides isDark,
    ) {
        content()
    }
}
